import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Organizer } from 'interface'
import axiosClient from 'utils/axiosClient'

const initialState: { list: Organizer[] } = {
  list: [],
}

export const getOrganizer = createAsyncThunk(
  'Organizer/getOrganizer',
  async (id: string | number) => {
    const { data } = await axiosClient.get('/api/organizer/' + id)
    return data
  }
)

export const OrganizerSlice = createSlice({
  name: 'Organizer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrganizer.fulfilled, (state, { payload }) => {
      const index = state.list.findIndex((f) => f.id === payload.id)
      if (index >= 0) {
        state.list.splice(index, 1, payload)
      } else {
        state.list.push(payload)
      }
    })
  },
})

export const OrganizerAction = OrganizerSlice.actions

export const OrganizerReducer = OrganizerSlice.reducer
